import { openNativePopup } from './open-native-popup';

export const UtilsExternal = {
  openNativePopup
};
